export class HttpLoggingOptions {
  //This is really only for when calling httpClient from the log service - to prevent anm infinite loop
  //but there could be other scenarios too, maybe if the data is v.large or has sensitive content
  doNotLog: boolean = false;

  //Text to be shown in the snack bar in the event of the http call failing.
  //This is the text displayed to the user and does not impact what is logged back to the server.
  errorText: string = 'An error occured.';

  //Text to be shown in the snack bar in the event of the http call succeeding.
  successText: string = 'Success';

  //An identifier to be written in the log on the server to help find/group entri
  source?: string;

  //Determines whether the success snack bar should be shown to the user for each method
  private _displaySuccess: Map<string, boolean>;

  constructor() {
    this.initDisplaySuccess();
  }

  setDisplaySuccess(method: string, display: boolean) {
    this._displaySuccess.set(method, display);
  }
  getDisplaySuccess(method: string) {
    return this._displaySuccess.get(method) ?? true;
  }

  private initDisplaySuccess() {
    this._displaySuccess = new Map<string, boolean>();
    this._displaySuccess.set('GET', false);
    this._displaySuccess.set('HEAD', false);
    this._displaySuccess.set('POST', false);
    this._displaySuccess.set('PUT', false);
    this._displaySuccess.set('DELETE', false);
    this._displaySuccess.set('CONNECT', false);
    this._displaySuccess.set('OPTIONS', false);
    this._displaySuccess.set('TRACE', false);
    this._displaySuccess.set('PATCH', false);
  }
}
